import type { User } from 'src/types/user';

import { useAppSelector } from './store';

export const useUserData = (): User => useAppSelector(state => (state as { user: User }).user);
